import { IColumn, IData } from './types';

interface ITableCell {
  rowIndex: number;
  column: IColumn;
  data: IData;
}

const TableCell = (props: ITableCell) => {
  const { rowIndex, column, data } = props;
  const accessor = data[column.accessor || 'id'];

  return (
    <td className="static-table__cell">
      <span className="static-table__cell-value">
        {column.render?.({
          row: data,
          accessor,
          rowIndex,
        }) || accessor}
      </span>
    </td>
  );
};

export default TableCell;
